import render from './render-mustache.js';
import SearchComponent from './SearchComponent';

export const Nav = (container, props) => {
    const template = `
        <nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top shadow-sm">
            <a class="navbar-brand" href="#"><i>KasiFood</i></a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent">
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse" id="navbarSupportedContent">
                <ul class="navbar-nav mr-auto">
                    {{#links}}
                        <li class="nav-item active">
                            <a class="nav-link" href="#">{{.}}</a>
                        </li>
                    {{/links}}
                </ul>
            </div>
        </nav>
    `;
    render(container, 'innerHTML', template, { links: props.links });

    const searchForBusinesses = (placeName, by) => {
        const togglerBtn = document.querySelector('.navbar-toggler');
        const collapseNav = document.querySelector('#navbarSupportedContent')
        if (!togglerBtn.classList.contains('collapsed')) {
            props.showBusinesses(placeName, by);
            togglerBtn.classList.add('collapsed');
            collapseNav.classList.remove('show');
        }
    }
    const searchForm = new SearchComponent(
        document.getElementById('navbarSupportedContent'),
        { searchData: props.searchData, handleSearch: searchForBusinesses, getTenMatchingWords: props.getTenMatchingWords }
    );
}

export default Nav;
